import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../Translations';

function EmptyRecentActivity() {
  return (
    <div className="flex flex-col items-center justify-center">
      <Typography
        as="h1"
        fontWeight="semibold"
        variant="bodyMedium"
        className="leading-5 mb-1 text-center"
        color="dark"
      >
        <T kind="No activity yet" />
      </Typography>
      <Typography as="p" variant="bodySmall" className="leading-5 text-center my-2" color="dark">
        <T kind="It seems like there haven’t been any recent activities in your organization yet." />
      </Typography>
    </div>
  );
}

export default observer(EmptyRecentActivity);
